module.exports = __webpack_public_path__ + "img/moon.98af7b61.png";